/**
 * Video Player
 */

// Vendors
import $ from 'jquery';

$('[data-video-play]').on('click', event => {
  event.preventDefault();

  const videoId = $(event.currentTarget).data('video-id');
  const videoFrame = document.createElement('iframe');

  videoFrame.className = 'video-player__iframe';
  videoFrame.setAttribute('allowFullScreen', '');

  if (videoId === '' || videoId === undefined) {
    return;
  } else {
    videoFrame.src = `https://www.youtube.com/embed/${videoId}?modestbranding=1&autohide=1&showinfo=0&autoplay=1&rel=0`;
  }

  $(event.currentTarget)
    .closest('.video-player')
    .addClass('video-player--playing');

  $(event.currentTarget)
    .closest('.video-player')
    .append(videoFrame);
});
